export default "__VITE_ASSET__v72qtzkgFJ8gd8FvV86kLQ__"